import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function ImageComparison({
  before,
  after,
  beforeLabel = "Damals",
  afterLabel = "Heute",
  caption,
}) {
  const [position, setPosition] = useState(50);
  if (!before || !after) return null;

  return (
    <figure className="image-comparison" data-testid="historical-comparison">
      <div className="image-comparison__stage">
        <img src={fileUrl(after)} alt={`${afterLabel}: derselbe Ort`} className="image-comparison__image" draggable="false" />
        <img
          src={fileUrl(before)}
          alt={`${beforeLabel}: derselbe Ort`}
          className="image-comparison__image image-comparison__image--before"
          style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
          draggable="false"
        />

        <span className="image-comparison__label image-comparison__label--before">{beforeLabel}</span>
        <span className="image-comparison__label image-comparison__label--after">{afterLabel}</span>
        <span className="image-comparison__divider" style={{ left: `${position}%` }} aria-hidden="true">
          <span className="image-comparison__handle"><MoveHorizontal className="h-4 w-4" /></span>
        </span>
        <input
          className="image-comparison__range"
          type="range"
          min="0"
          max="100"
          value={position}
          onChange={(event) => setPosition(Number(event.target.value))}
          aria-label={`${beforeLabel} und ${afterLabel} vergleichen`}
        />
      </div>
      <figcaption className="image-comparison__caption">
        <span>Zieh die Linie mit dem Finger.</span>
        {caption ? <span>{caption}</span> : null}
      </figcaption>
    </figure>
  );
}
